import store from '@/store';

interface NumberFormatMixinInterface {
  methods: {
    formatNumber: (value: number | string) => string;
    getAmountInCurrency: (value: number | string) => string;
  };
}

export const numberFormatMixin: NumberFormatMixinInterface = {
  methods: {
    formatNumber(value: number | string, fractions: number = 2): string {
      return Number(value).toLocaleString(navigator.language ?? navigator.languages[0] ?? 'en-GB', {
        minimumFractionDigits: fractions,
        maximumFractionDigits: fractions
      });
    },
    getAmountInCurrency(value: number | string): string {
      const currencySymbol: string = store.getters.currencySymbol;

      if (Number(value) < 0) {
        return `(${currencySymbol}${this.formatNumber(Math.abs(Number(value)) / 100)})`; // dividing by 100 as initial value is in cents/pennies
      }

      return `${currencySymbol}${this.formatNumber(Number(value) / 100)}`;
    }
  }
};
